import React, { useState } from 'react'
import {
  Label,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap'
import {
  Controller,
  Control,
  FieldValues,
  FieldErrors,
  UseFormSetValue,
  UseFormGetValues,
  UseFormSetError
} from 'react-hook-form'
import ICSToolTip from '../ICSToolTip/ICSToolTip'
import './ICSTextInput.css'

const ICSTextInput = ({
  name,
  id = `${name}Input`,
  control,
  errors,
  defaultValue = '',
  placeholder = `${name.charAt(0).toUpperCase() + name.slice(1)}...`,
  helpText,
  isSubmitted,
  autoComplete = 'on',
  maxCharCount = 0,
  hidden = false,
  isPassword = false,
  label
}: ICSTextInputProps) => {
  const [showPassword, setShowpassword] = useState(isPassword)
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched }
      }) => {
        return (
          <>
            {!hidden && (
              <Label for={id} className="input-label">
                {label}
                {helpText && (
                  <ICSToolTip
                    id={`${name}ToolTip`}
                    text={helpText}
                    target={`#${name}ToolTip`}
                  />
                )}
              </Label>
            )}
            <InputGroup className="Inp ">
              <Input
                id={id}
                onBlur={onBlur}
                onChange={onChange}
                placeholder={placeholder}
                type={showPassword ? 'password' : 'text'}
                valid={
                  !invalid &&
                  (isTouched || isSubmitted) &&
                  value !== defaultValue
                }
                value={value}
                autoComplete={autoComplete}
                invalid={(invalid && (isTouched || isSubmitted)) || false}
                innerRef={ref}
                data-testid={`${name}Input`}
                hidden={hidden}
                style={{ color: 'black' }}
              />
              {name === 'password' && (
                <span
                  onClick={() => setShowpassword(!showPassword)}
                  className={`pass-icon glyphicons ${
                    !showPassword
                      ? 'glyphicons-eye-close'
                      : 'glyphicons-eye-open'
                  }`}
                  style={{
                    zIndex: 3,
                    height: '18px',
                    width: '18px',
                    position: 'absolute',
                    right: '10px',
                    top: '10px',
                    cursor: 'pointer',
                    opacity: '0.6'
                  }}
                />
              )}
              {maxCharCount > 0 && (
                <InputGroupAddon addonType="append">
                  <InputGroupText id={`${name}CharCount`}>
                    {value?.length || 0}/{maxCharCount}
                  </InputGroupText>
                </InputGroupAddon>
              )}
              <FormFeedback
                valid={errors?.[name] ? false : true}
                role="alert"
                id={`${name}Error`}
              >
                {errors?.[name]?.message}
              </FormFeedback>
            </InputGroup>
          </>
        )
      }}
    />
  )
}

export default ICSTextInput

type ICSTextInputProps<TFieldValues extends FieldValues = FieldValues> = {
  id?: string
  name: string
  control?: Control<TFieldValues>
  errors?: FieldErrors<TFieldValues>
  defaultValue?: string
  placeholder?: string
  helpText?: string
  isSubmitted?: boolean
  autoComplete?: string
  maxCharCount?: number
  hidden?: boolean
  setValue?: UseFormSetValue<FieldValues>
  getValues?: UseFormGetValues<FieldValues>
  setError?: UseFormSetError<FieldValues>
  isPassword?: boolean
  label?: string
}
